import Card from 'components/common/ui-kit/Card';
import terms from 'i18n';

type ContractInformingProps = {
  className?: string;
  disabled?: boolean;
  required?: boolean;
  hasConcent: boolean;
};

export default function Consent({
  hasConcent,
  ...rest
}: ContractInformingProps) {
  return (
    <Card {...rest} title={terms.CONSENT}>
      {hasConcent ? 'Да' : 'Нет'}
    </Card>
  );
}
